// ProtectedRoute.jsx
import { useEffect, useState } from 'react';
import { auth } from '../firebase';
import { isAdminEmail } from '../utils/adminAccess';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user && isAdminEmail(user.email)) {
        setAuthorized(true);
      } else {
        setAuthorized(false);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return <div>Caricamento...</div>;
  }

  if (!authorized) {
return (
  <div className="auth-page" style={{ 
    background: "linear-gradient(135deg, #12181f 0%, #263848 100%)",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem"
  }}>
    <div className="auth-container" style={{ 
      background: "white",
      border: "2px solid transparent",
      backgroundClip: "padding-box, border-box",
      backgroundOrigin: "padding-box, border-box",
      backgroundImage: "linear-gradient(white, white), linear-gradient(135deg, var(--brand-secondary), var(--brand-accent))"
    }}>
      <div className="auth-content">
        <div className="text-center mb-4">
          <div className="bg-brand-accent-light d-inline-flex p-3 rounded-circle mb-3" 
               style={{ border: "2px solid var(--brand-accent)" }}>
            <i className="bi bi-shield-lock-fill" style={{ fontSize: "2rem", color: "var(--brand-accent)" }}></i>
          </div>
          
          <h2 className="text-brand-primary fw-bold mb-3">
            Accesso Negato
          </h2>
          
          <p className="text-muted mb-4">
            Non hai i permessi necessari per visualizzare questa pagina.
            Se pensi che si tratti di un errore, contatta l'amministratore.
          </p>
        </div>
        
        <div className="d-flex gap-3 justify-content-center flex-wrap mb-4">
          <button
            onClick={() => window.location.href = '/'}
            className="btn-brand-primary px-4 py-2"
            style={{
              border: "none",
              borderRadius: "8px",
              fontWeight: "500",
              transition: "var(--transition)",
              background: "linear-gradient(135deg, var(--brand-primary), var(--brand-primary-light))",
              color: "white",
              boxShadow: "0 4px 12px rgba(38, 56, 72, 0.3)"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 16px rgba(38, 56, 72, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 12px rgba(38, 56, 72, 0.3)";
            }}
          >
            Torna alla Home
          </button>
          
          <button
            onClick={() => window.history.back()}
            className="btn-outline-brand-secondary px-4 py-2"
            style={{
              border: "2px solid var(--brand-secondary)",
              borderRadius: "8px",
              fontWeight: "500",
              transition: "var(--transition)",
              background: "transparent",
              color: "var(--brand-secondary)"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "var(--brand-secondary)";
              e.target.style.color = "white";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "var(--brand-secondary)";
              e.target.style.transform = "translateY(0)";
            }}
          >
            Indietro
          </button>
        </div>
        
        <div className="bg-brand-primary-light p-3 rounded text-center"
             style={{ border: "1px dashed var(--brand-secondary)" }}>
          <p className="small mb-0">
            Codice errore: <span className="text-brand-accent fw-semibold">403</span>
          </p>
        </div>
      </div>
    </div>
  </div>
);
  }

  return children;
};

export default ProtectedRoute;
